// Dynamic model list fetching from the API server.

interface ModelsResponse {
  models: string[];
}

/**
 * Fetch available models for a given LLM backend.
 * Returns an empty array on any failure (network, timeout, bad JSON, etc.).
 */
export async function fetchAvailableModels(
  backend: string,
  baseUrl: string,
  apiKey?: string,
): Promise<string[]> {
  try {
    const params = new URLSearchParams({ backend });
    if (baseUrl) params.set('base_url', baseUrl);
    if (apiKey) params.set('api_key', apiKey);

    const resp = await fetch(`/api/fastapi/models?${params.toString()}`, {
      credentials: 'same-origin',
      signal: AbortSignal.timeout(8_000),
    });

    if (!resp.ok) return [];
    const data = (await resp.json()) as ModelsResponse;
    return Array.isArray(data.models) ? data.models : [];
  } catch {
    return [];
  }
}
